import { connect } from 'react-redux';
// @ts-expect-error untyped module
import { getId } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import { isMessageRejected } from '../../pubsub/selectors/getRejectedMessage';
export const withRejectedMessage = WrappedComponent => {
  const mapStateToProps = (state, ownProps) => {
    const messageId = getId(ownProps.message);
    const isRejected = isMessageRejected(state, messageId);
    return {
      isRejected
    };
  };
  const Connected = connect(mapStateToProps)(WrappedComponent);
  Connected.displayName = `withRejectedMessage(${WrappedComponent.displayName || WrappedComponent.name || 'Component'})`;
  return Connected;
};